/*
 * NOTE: This is an auto-generated file created by Iconic.
 *
 * You should not need to edit this file directly; if you need to add/remove any
 * icon modules, you can rebuild it by running `yarn icons:make`.
 */
import * as React from 'react'

import VacasaWrapper from '../Wrapper'

const VacasaUser2: React.FunctionComponent = () => {
  return (
    <VacasaWrapper id="user2" viewBox="0 0 14 14">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.25 12.2503C12.25 12.5725 11.9888 12.8337 11.6667 12.8337C11.3445 12.8337 11.0833 12.5725 11.0833 12.2503V11.0837C11.0833 10.1172 10.2998 9.33366 9.33333 9.33366H4.66667C3.70017 9.33366 2.91667 10.1172 2.91667 11.0837V12.2503C2.91667 12.5725 2.6555 12.8337 2.33333 12.8337C2.01117 12.8337 1.75 12.5725 1.75 12.2503V11.0837C1.75 9.47283 3.05584 8.16699 4.66667 8.16699H9.33333C10.9442 8.16699 12.25 9.47283 12.25 11.0837V12.2503ZM7 7.00033C5.38917 7.00033 4.08333 5.69449 4.08333 4.08366C4.08333 2.47283 5.38917 1.16699 7 1.16699C8.61083 1.16699 9.91667 2.47283 9.91667 4.08366C9.91667 5.69449 8.61083 7.00033 7 7.00033ZM7 5.83366C7.9665 5.83366 8.75 5.05016 8.75 4.08366C8.75 3.11716 7.9665 2.33366 7 2.33366C6.0335 2.33366 5.25 3.11716 5.25 4.08366C5.25 5.05016 6.0335 5.83366 7 5.83366Z"
        fill="currentColor"
      ></path>
    </VacasaWrapper>
  )
}

export default React.memo(VacasaUser2)
